import { render, staticRenderFns } from "./ImgUnderlineUltraBlueMarine.vue?vue&type=template&id=f72678ee&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports